import { useState } from 'react'
import { UserAvatar } from '@/components/user-avatar'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from '@journ/ui/dropdown-menu'
import { Link, useNavigate } from '@/libs/router'
import { useIntlayer } from 'react-intlayer'
import { useSelector } from '@/libs/state'
import { logout } from '@/features/auth/wiring'
import { session$ } from '@/features/auth/store'
import { ThemeSwitch } from '@/features/settings/ui/theme-switch'

const UserMenu = () => {
	const content = useIntlayer('user-menu')
	const navigate = useNavigate()
	const user = useSelector(() => session$.user.get())
	const [isSigningOut, setIsSigningOut] = useState(false)

	const displayName = user?.fullName ?? user?.email ?? content.fallbackName.value
	const email = user?.email ?? ''

	const handleSignOut = async (): Promise<void> => {
		setIsSigningOut(true)
		await logout()
		await navigate({ to: '/login' })
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button type='button' className='cursor-pointer rounded-full'>
					<UserAvatar name={displayName} avatarUrl={user?.avatarUrl} size='md' />
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className='w-60' sideOffset={10} align='end'>
				<DropdownMenuLabel>
					<div className='flex flex-col'>
						<span className='truncate line-clamp-1 max-w-[180px] block text-xs'>{displayName}</span>
						<span className='truncate text-xs text-606060 font-normal'>{email}</span>
					</div>
				</DropdownMenuLabel>
				<DropdownMenuSeparator />
				<DropdownMenuGroup>
					<Link to='/account'>
						<DropdownMenuItem className='text-xs'>{content.account}</DropdownMenuItem>
					</Link>
					<Link to='/settings/members'>
						<DropdownMenuItem className='text-xs'>{content.settings}</DropdownMenuItem>
					</Link>
				</DropdownMenuGroup>
				<DropdownMenuSeparator />
				<div className='flex flex-row justify-between items-center px-2 py-1.5'>
					<p className='text-xs'>{content.theme}</p>
					<ThemeSwitch />
				</div>
				<DropdownMenuSeparator />
				<DropdownMenuItem
					className='text-xs text-destructive focus:text-destructive'
					disabled={isSigningOut}
					onClick={() => void handleSignOut()}
				>
					{isSigningOut ? content.signingOut : content.signOut}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}

export { UserMenu }
